import PolicyCreatedEvent from '@/domains/policies/events/PolicyCreatedEvent';

const PolicyEvents = {
  PolicyCreated: PolicyCreatedEvent,
};

export default PolicyEvents;
